import { render } from "./section-post.vue?vue&type=template&id=2b7422a6"
import script from "./section-post.vue?vue&type=script&lang=js"
export * from "./section-post.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__